import React, { useState } from "react";
import { Brand } from "./shared/Brand";
import WhatsAppButton from "./WhatsAppButton";

// A4 printable Gap Analysis pages (6 pages, in order).
const PAGES = [
  { src: "/brand/gap/page1.jpg", alt: "Gap Analysis — Your Organisation & Your Building" },
  { src: "/brand/gap/page2.jpg", alt: "Gap Analysis — Your Building continued & Your Energy & Water" },
  { src: "/brand/gap/page3.jpg", alt: "Gap Analysis — Equipment On Site & Previous Investments" },
  { src: "/brand/gap/page4.jpg", alt: "Gap Analysis — Your Challenges & Goals" },
  { src: "/brand/gap/page5.jpg", alt: "Gap Analysis — Objectives & Notes" },
  { src: "/brand/gap/page6.jpg", alt: "Gap Analysis — Notes" },
];

function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <nav className="evnav">
      <div className="wrap navin">
        <a href="/"><Brand /></a>
        <div className="navlinks">
          <a href="/">Home</a>
          <a href="/how-it-works">How It Works</a>
          <a href="/assets">What We Monitor</a>
          <a href="/gap-analysis" className="btn" style={{ padding: "10px 20px" }}>Complimentary Gap Analysis</a>
        </div>
        <button className="navtoggle" onClick={() => setOpen((o) => !o)} aria-label="Menu" aria-expanded={open} data-testid="gp-nav-toggle">
          {open ? (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          ) : (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
          )}
        </button>
      </div>
      {open && (
        <div className="navmobile">
          <a href="/">Home</a>
          <a href="/how-it-works">How It Works</a>
          <a href="/assets">What We Monitor</a>
          <a href="/gap-analysis" className="btn">Complimentary Gap Analysis</a>
        </div>
      )}
    </nav>
  );
}

export default function GapAnalysisPages() {
  return (
    <div className="evg gappages" data-testid="gap-pages">
      <Nav />

      <header className="gp-hero no-print">
        <div className="wrap">
          <div className="eyebrow" style={{ textAlign: "left" }}>KNOWLEDGE BEFORE INVESTMENT</div>
          <h1>Gap Analysis <span className="g">Pages</span></h1>
          <p className="gp-lead">
            Our A4 Gap Analysis questionnaire. Print it and complete by hand, or fill it in online in a few minutes —
            there are no wrong answers. It helps us prepare your <b>free, no-obligation Gap Analysis.</b>
          </p>
          <div className="gp-actions">
            <button className="fl-print" onClick={() => window.print()} data-testid="gp-print">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9" /><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" /><rect x="6" y="14" width="12" height="8" /></svg>
              Print / Save as PDF
            </button>
            <a href="/gap-analysis" className="btn" data-testid="gp-fill-online">Fill In Online Instead</a>
          </div>
        </div>
      </header>

      <div className="gp-banner no-print" data-testid="gp-online-banner">
        <div className="wrap gp-banner-in">
          <div className="gp-banner-txt">
            <span className="gp-banner-h">Prefer to do it now? <span className="g">Takes 2 minutes.</span></span>
            <span className="gp-banner-s">Fill it in online and it comes straight to us — no printing, no posting.</span>
          </div>
          <a href="/gap-analysis" className="btn gp-banner-btn" data-testid="gp-banner-cta">Complete It Online</a>
        </div>
      </div>

      <div className="gp-sheets">
        {PAGES.map((p, i) => (
          <div className="gp-sheet" key={p.src} data-testid={`gap-page-${i + 1}`}>
            <img src={p.src} alt={p.alt} loading={i === 0 ? "eager" : "lazy"} />
          </div>
        ))}
      </div>

      <div className="gp-foot no-print">
        <div className="wrap">
          <div className="gp-cta">
            <div className="gp-cta-txt">
              Ready when you are — <span className="g">your Gap Analysis is completely free.</span>
            </div>
            <a href="/gap-analysis" className="btn" data-testid="gp-book-cta">Book Your Free Gap Analysis</a>
          </div>
        </div>
      </div>

      <WhatsAppButton />
    </div>
  );
}
